import { Injectable } from '@angular/core';
import { ServiceConstants } from '@emi/shared/constants';
import { HttpService } from '@emi/shared/data-access';
import {
    SearchOption,
    SkuSearchResult,
    TableRow,
    SearchSuggestionRequest,
    ISearchSuggestionResponse,
} from '@emi/shared/models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SkuSearchService {
    constructor(private httpService: HttpService) {}

    //TODO
    public getSkuSearch(searchTerm: string, searchOption: SearchOption): TableRow[] {
        const skuDetails = new SkuSearchResult(
            0,
            `${searchTerm} | ${searchOption.label}`,
            '',
            '',
            'Country Name',
            'Industry Name',
            'Category Name',
            'Sub-Category Name',
            'Supplier Name',
            'Brand Name',
            'Sub-brand Name',
            'Size',
            'Units',
            'Size'
        );

        return [
            {
                id: 1,
                skuDetails: skuDetails,
                feedbackReviewPending: true,
                totalSkuSize: 20,
                lastSeenPrice: 1.29,
            },
            {
                id: 2,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 12,
                lastSeenPrice: 4.99,
            },
            {
                id: 3,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 24,
                lastSeenPrice: 19,
            },
            {
                id: 4,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 1,
                lastSeenPrice: 199,
            },
            {
                id: 5,
                skuDetails: skuDetails,
                feedbackReviewPending: true,
                totalSkuSize: 23,
                lastSeenPrice: 1.99,
            },
            {
                id: 6,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 2,
                lastSeenPrice: 2.99,
            },
            {
                id: 7,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 12,
                lastSeenPrice: 99,
            },
            {
                id: 8,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 6,
                lastSeenPrice: 1.1,
            },
            {
                id: 9,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 3,
                lastSeenPrice: 1.99,
            },
            {
                id: 10,
                skuDetails: skuDetails,
                feedbackReviewPending: false,
                totalSkuSize: 7,
                lastSeenPrice: 1.5,
            },
        ];
    }

    public getSearchSuggestions(searchRequest: SearchSuggestionRequest): Observable<ISearchSuggestionResponse> {
        return this.httpService.postHttp(ServiceConstants.SKU_SEARCH_SUGGESTION, searchRequest)
    }
}
